module.exports = __webpack_public_path__ + "img/product-plteacher-pl-01.e2bd7fce.png";